import { useFeatureFlag } from "@hooks";
import { FeatureFlag } from "@enums";
import SetupAutopaySimplified from "./setup-autopay-simplified";
import SetupAutopayToggled from "./setup-autopay-toggled";

const SetupAutopay = () => {
    const { value: isAutopayOnboardingStepSimplified, loading } = useFeatureFlag(
        FeatureFlag.AUTOPAY_ONBOARDING_STEP_SIMPLIFIED,
        false
    );

    if (loading) return null;

    return isAutopayOnboardingStepSimplified
        ? <SetupAutopaySimplified />
        : <SetupAutopayToggled />;
};

export default SetupAutopay;
